import {Box, Button} from "@mui/material";
import FiatSelector from "./FiatSelector";
import {CreditCardInterface, FiatInterface, FormInterface} from "./types";
import {useTranslation} from "react-i18next";
import {useCallback, useEffect, useState} from "react";
import client from "../../config/client";
import {useAppSelector} from "../../app/hooks";
import CreditCardSelector from "./CreditCardSelector";
import DepositAmount from "./DepositAmount";
import {selectAccount, selectAmount} from "./depositFormSlice";

export default function FiatForm(props: FormInterface){
    const {t} = useTranslation();
    const amount = useAppSelector(selectAmount);
    const account = useAppSelector(selectAccount);

    const [cards, setCards] = useState<CreditCardInterface[]>([])

    const [items, setItems] = useState<FiatInterface[]>([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        client.get('/v4/assets/fiats').then((resp) => {
            const data = resp.data.data;

            setItems(data.map((r: any) => {
                return {
                    value: r.symbol,
                    country: 'IRAN',
                    label: r.name,
                    balance: r.total,
                    icon: r.icon
                }
            }))
        })
    }, [])

    useEffect(() => {
        client.get('/v1/credit-cards/approved').then((resp) => {
            setCards(
                resp.data.data.map((r: any) => {
                    return {
                        value: r.id,
                        label: r.card,
                        icon: r.icon
                    };
                })
            )
        })
    }, [])


    const handlePayBtn = useCallback(() => {
        setLoading(true)
        let data = {
            amount: amount,
            account: account,
            type: 'online',
            redirect_url_on_return: window.location.href,
        };
        client.post('/v1/wallet', data).then((resp) => {
            window.location.href = resp.data.redirect;
        }).finally(()=>setLoading(false))
    }, [amount, account]);

    return (
        <Box hidden={props.value !== props.index}>
            <Box>
                <FiatSelector items={items} />
            </Box>
            <Box>
                <CreditCardSelector items={cards} label={t('card_number') as string} />
            </Box>
            <Box>
                <DepositAmount />
            </Box>
            <Box>
                <Button disabled={loading} onClick={handlePayBtn} size={'large'} fullWidth variant={'contained'}>{t('pay')}</Button>
            </Box>
        </Box>
    );
}
